import type { Landmark } from '../../../data/types';
import type { Ring } from '../../../geo/types';
import type { MeshBuilder, VertexStyle } from '../../mesh/meshBuilder';
import type { MasonryStyles } from './masonry';
import { BOOM_BLOCKHOUSES, buildBoomBlockhouse } from './boomBlockhouse';
import { buildSintOlofspoort, sintOlofspoortObstacles } from './sintOlofspoort';

export function buildWaterfrontDefence(
  builder: MeshBuilder,
  landmark: Landmark,
  styles: { readonly masonry: MasonryStyles; readonly timber: VertexStyle }
): boolean {
  if (landmark.id === 'landmark-sint-olofspoort') buildSintOlofspoort(builder, landmark, styles);
  else if (BOOM_BLOCKHOUSES.has(landmark.id)) buildBoomBlockhouse(builder, landmark, styles);
  else return false;
  return true;
}

export function waterfrontDefenceObstacles(landmark: Landmark): readonly Ring[] | null {
  return landmark.id === 'landmark-sint-olofspoort' ? sintOlofspoortObstacles(landmark) : null;
}
